import React, { type FunctionComponent, Fragment } from 'react'
import { css, Global } from '@emotion/react'
import { type EmotionStyles } from 'gin-and-tonic/utils/styling/types'
import { globalStyles } from 'gin-and-tonic/utils/styling/globalStyles'
import { spacing } from 'gin-and-tonic/foundation/spacing'

const wrapperStyles = css({
  minWidth: '100vw',
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  maxWidth: 1024,
  marginTop: spacing.X0,
  marginBottom: spacing.X0,
  marginLeft: 'auto',
  marginRight: 'auto',
})

interface Props extends EmotionStyles {}

export const AppProviderStyling: FunctionComponent<Props> = ({ styles, children }) => (
  <Fragment>
    <Global styles={css(globalStyles)} />
    <div css={css(wrapperStyles, styles)}>{children}</div>
  </Fragment>
)
